<template>
  <carousel
    class="carousel__meta"
    ref="carouselSelector"
    :navigationEnabled="false"
    :per-page="1"
    :perPageCustom="[
      [768, 1],
      [1024, 2],
    ]"
    :pagination-enabled="false"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
  >
    <slide align="center" class="slide-meta">
      <div
        class="banner__image-meta"
        :style="'background-image: url(' + banner1 + ')'"
      ></div>
      <p class="banner__data">Encerrado</p>
      <a href="https://www.instagram.com/reel/CXrh6NIJlP1/" target="blank">
        <button class="banner__button">Veja como foi</button>
      </a>
      <div class="bolinha"></div>
      <div class="linha_ linha-um"></div>
    </slide>
    <slide align="center" class="slide-meta">
      <div
        class="banner__image-meta"
        :style="'background-image: url(' + banner2 + ')'"
      ></div>
      <p class="banner__data">Encerrado</p>
      <a href="https://www.instagram.com/reel/CZxIf-7pFUK/" target="blank">
        <button class="banner__button">Veja como foi</button>
      </a>
      <div class="bolinha"></div>
      <div class="linha_ linha-dois"></div>
    </slide>
    <!-- <slide align="center" class="slide-meta">
      <div
        class="banner__image-meta"
        :style="'background-image: url(' + banner3 + ')'"
      ></div>
      <p class="banner__data">Em breve</p>
      <a href="#" target="blank" >
        <button class="banner__button">Em breve</button>
      </a>
      <div class="bolinha"></div>
    </slide> -->
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["banners"],
  data() {
    return {
      width: screen.width,
      banner1: "/img/metaverso-logo.png",
      banner2: "/img/futurismo-logo.png",
      banner3: "img/experiencia.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>

<style lang="scss" rel="stylesheet" media="all">
@import "resources/assets/sass/website/_variables.scss";

.carousel_meta {
  width: 100%;
  height: 100vh;
}
.slide-meta {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.banner__image-meta {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 125px;
  width: 250px;
}
.banner__button {
  color: $black;
  background-color: $pink;
  border: none;
  font-family: $font-geo;
  font-weight: bold;
  font-size: 25px;
  text-transform: uppercase;
  width: 250px;
  height: 80px;
  &:hover,
  &:focus {
    box-shadow: 0 0.5em 0.5em -0.4em $pink;
    transform: translateY(-0.25em);
  }
}
.banner__data {
  color: black;
  font-family: $font-geo;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 140%;
  margin-bottom: 30px;
}
.bolinha {
  background-color: $pink;
  border-radius: 50%;
  margin-top: 20px;
  height: 20px;
  width: 20px;
}
.linha_ {
  background-color: $pink;
  position: absolute;
  bottom: 8px;
  width: 500px;
  height: 4px;
}
.linha-um {
  right: 0px;
  position: absolute;
  width: 555px;
  @media (max-width: 1200px){
    width: 465px;
  }
  @media (max-width: 1018px){
    width: 310px;
  }
  @media (max-width: 996px){
    width: 350px;
  }
  @media (max-width: 775px){
    width: 250px;
  }
  @media (max-width: 500px){
    width: 225px;
  }
  @media (max-width: 450px){
    width: 197px;
  }
  @media (max-width: 400px){
    width: 170px;
  }
  @media (max-width: 350px){
    width: 145px;
  }
  
}
</style>
